import { Card, CompartmentCard } from "@/src/components/cards";
import {
  closeDrawer,
  openConfirmDialog,
  openDrawer,
} from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import StaggeredAnimation from "@/src/components/staggeredAnimationComponent";
import { Bed, Hospitalisation, Patient } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, getUserShortName, uid } from "@/src/utils/utils";
import moment from "moment";
import { useState } from "react";
import {
  HospitalisationBedsChoice,
  openHospitalisationDrawer,
} from "../hospitalisation/hospitalisationHook";

export function HospitalisationsHistory({ patient }: { patient: Patient }) {
  const [reload, setReload] = useState(0);
  return (
    <CompartmentCard
      title={"Hospitalisations"}
      color="blue"
      onClick={async () => {
        await openHospitalisationItem(null, patient, () => {
          setReload((prev) => prev + 1);
        });
      }}
    >
      <FetchableList
        queryKey={["HospitalisationsHistory", patient.id, reload]}
        queryFn={() =>
          apiFetch("hospitalisations", "loadMany", {
            patientId: patient.id,
            bedsIds: null,
          })
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((item, index) => {
              return (
                <StaggeredAnimation key={uid()} index={index}>
                  <HospitalisationHistoryItem
                    item={item}
                    patient={patient}
                    isDeletable={true}
                    onConfirm={(item) => {
                      setReload((prev) => prev + 1);
                    }}
                  />
                  {/* <ConfidentialityCard
                  item={item}
                  onChange={async () => {
                    setReload((prev) => prev + 1);;
                  }}
                > */}

                  {/* </ConfidentialityCard> */}
                </StaggeredAnimation>
              );
            })}
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}

export function HospitalisationHistoryItem({
  item,
  patient,
  isDeletable,
  onConfirm,
  onClick,
}: {
  item: Hospitalisation;
  patient: Patient;
  isDeletable: boolean;
  onConfirm: (item: Hospitalisation) => void;
  onClick?: () => void;
}) {
  return (
    <Card
      color="blue"
      title={"Hospitalisation"}
      onClick={
        onClick != null
          ? onClick
          : async () => {
              console.log("item", item);

              await openHospitalisationItem(item, patient, onConfirm);
            }
      }
      onDelete={
        isDeletable == true
          ? async () => {
              await openConfirmDialog({
                onConfirm: async () => {
                  await apiFetch("general", "deleteAny", {
                    id: item?.id,
                    table: "hospitalisations",
                  });
                  onConfirm?.(item);
                },
              });
            }
          : undefined
      }
    >
      <div>
        <span className="">Du {moment(item._date).format("LL")}</span>
        {item.discharge?.exitDate && (
          <span className="">
            {" "}
            au {moment(item.discharge?.exitDate).format("LL")}
          </span>
        )}
        {item.discharge?.exitDate && (
          <span className="gray">
            {" "}
            ({moment(item.discharge?.exitDate).diff(item._date, "days")} jours)
          </span>
        )}
        <div>{getUserShortName(item?.creator) || ""}</div>
      </div>
      {item.diagnostics?.length != 0 && (
        <div>
          {item.diagnostics?.map((refAnswer, index) => {
            if (!refAnswer) return null;
            return (
              <div key={refAnswer.id} className="bold">
                {refAnswer?.reference?.name || ""}
              </div>
            );
          })}
        </div>
      )}
      {item.motives?.length != 0 && (
        <div>
          {item.motives?.map((refAnswer, index) => {
            if (!refAnswer) return null;
            return (
              <div key={refAnswer?.id}>
                <div className="bold">{refAnswer?.reference?.name || ""}</div>
                <div className="gray">{refAnswer?.notes || ""}</div>
              </div>
            );
          })}
        </div>
      )}
      <div className="bold">{item?.conclusion}</div>
    </Card>
  );
}

async function openHospitalisationItem(
  item: Hospitalisation | null,
  patient: Patient,
  onConfirm: (item: Hospitalisation) => void
) {
  if (!item) {
    let bed: Bed | null = null;
    await openDrawer({
      id: "bedDrawer",
      title: "Lit",
      content: (
        <HospitalisationBedsChoice
          service={USER.get()?.service!}
          onSelect={(newBed) => {
            bed = newBed;
            closeDrawer("bedDrawer");
          }}
        />
      ),
    });

    if (!bed) return;

    let result = await apiFetch("hospitalisations", "addOne", {
      hospitalisation: {
        patient,
        bed,
        status: "inProgress",
        type: "hospitalisation",
        creator: getUserId(),
      },
    });
    if (!result) return;
    item = result;
  }
  if (!item?.id) throw new Error("Aucune hospitalisation trouvée.");

  await openHospitalisationDrawer({
    itemId: item.id,
    onImmediateDischarge: async () => {},
    onConfirm: async (hospitalisation: any) => {
      onConfirm(hospitalisation);
    },
  });
}
